import React, { ReactElement, ButtonHTMLAttributes, useContext } from 'react';
import classNames from 'classnames';
import { SSRApiContext } from '@ecommerce/nest-ssr/common';

import './button.scss';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: 'green' | 'white';
    uppercase?: boolean;
    wrapper?: boolean;
}

const Button: React.FC<ButtonProps> = (
    {
        color = 'green',
        type = 'button',
        uppercase,
        wrapper,
        className,
        children,
        ...props
    }
): ReactElement => {
    const api = useContext(SSRApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const classes = classNames(className,
        'button',
        {
            [`button--color-${color}`]: !wrapper,
            'button--uppercase': uppercase,
            'button--wrapper': wrapper,
            'button--mobile': api.getDevice() === 'mobile'
        });

    return (

        <button type={type} className={classes} {...props}>
            {children}
        </button>
    );
};

export default Button;
